export const savingsPlanTeaserProducts = [
  {
    name: 'Amundi MSCI World',
    isin: 'IE000BI8OT95',
  },
  {
    name: 'iShares S&P 500',
    isin: 'IE00B5BMR087',
  },
  {
    name: 'Xtrackers DAX',
    isin: 'LU0274211480',
  },
];
